import React from 'react';
import { IconProps } from '../types';

export const MobileAppDevelopmentIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M7.99992 1.33333H23.9999C24.7072 1.33333 25.3854 1.61428 25.8855 2.11438C26.3856 2.61447 26.6666 3.29275 26.6666 3.99999V28C26.6666 28.7072 26.3856 29.3855 25.8855 29.8856C25.3854 30.3857 24.7072 30.6667 23.9999 30.6667H7.99992C7.29267 30.6667 6.6144 30.3857 6.1143 29.8856C5.6142 29.3855 5.33325 28.7072 5.33325 28V3.99999C5.33325 3.29275 5.6142 2.61447 6.1143 2.11438C6.6144 1.61428 7.29267 1.33333 7.99992 1.33333Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M15.9998 26.6667C16.7362 26.6667 17.3332 26.0697 17.3332 25.3333C17.3332 24.597 16.7362 24 15.9998 24C15.2635 24 14.6665 24.597 14.6665 25.3333C14.6665 26.0697 15.2635 26.6667 15.9998 26.6667Z"
            fill={color}
        />
        <path
            d="M13.3334 10.6667L10.6667 13.3333L13.3334 16"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M18.6667 10.6667L21.3334 13.3333L18.6667 16"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
    </svg>
);
